//#region Components
import NavigateButton from "components/NavigateButton/NavigateButton";
//#endregion
//#region Styles
import { 
    Row, 
    SubtitleSection } from "components/styles";
//#endregion

const PageManager = ({
    caption,
    width,
    dataPaginator: {
        quantityPages,
        currentPage = "?",
        setCurrentPage,
        nextPage, backPage,
        formatted
    }
}) => {
    return (
        <Row justifyContent="flex-end" width={width}>
            <SubtitleSection fontWeight="400">{caption} {formatted || `${currentPage} de ${quantityPages}`}</SubtitleSection>
            <NavigateButton 
                onClick={() => backPage ? backPage() : setCurrentPage(currentPage - 1)} 
                angle="90deg"
                disabled={currentPage === 1}/>
            <NavigateButton
                onClick={() => nextPage ? nextPage() : setCurrentPage(currentPage + 1)}
                angle="270deg"
                disabled={currentPage >= quantityPages}/>
        </Row>
    );
}

export default PageManager;